"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _reactDeviceDetect = require("react-device-detect");
var _styles = _interopRequireDefault(require("./styles"));
var _index = _interopRequireDefault(require("../Drawer/index"));
var _Theme = require("../../contexts/Theme");
var _Bookmarks = require("../../contexts/Bookmarks");
var _Auth = require("../../contexts/Auth");
var _Bookmark = _interopRequireDefault(require("../../api/Bookmark"));
var _PdfReader = _interopRequireDefault(require("../../services/PdfReader"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function BottomNavigation(_ref) {
  var {
    pdf
  } = _ref;
  var {
    isPageBookmarked,
    setIsPageBookmarked,
    bookmarks,
    setBookmarks
  } = (0, _react.useContext)(_Bookmarks.BookmarksContext);
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var [openDrawer, setOpenDrawer] = (0, _react.useState)(false);
  var [title, setTitle] = (0, _react.useState)('');
  var [chapters, setChapters] = (0, _react.useState)([]);
  var [currentPage, setCurrentPage] = (0, _react.useState)();
  var {
    theme
  } = (0, _Theme.useTheme)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    if (pdf) {
      pdf.props.pdfDocument.getMetadata().then(metadata => setTitle(metadata.info.Title));
      pdf.props.pdfDocument.getOutline().then(chapterList => setChapters(chapterList));
    }
  }, [pdf]);
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    var onScroll = () => setCurrentPage(pdf.viewer.currentPageNumber);
    pdf.viewer.container.addEventListener('scroll', onScroll);
    return () => pdf.viewer.container.removeEventListener('scroll', onScroll);
  }, [pdf]);
  (0, _react.useEffect)(() => {
    if (!pdf) return;
    var res = bookmarks.some(bookmark => bookmark.page_reference === String(pdf.viewer.currentPageNumber));
    setIsPageBookmarked(Boolean(res));
  }, [currentPage, bookmarks, pdf, setIsPageBookmarked]);
  function loadBookmarks() {
    var {
      applicationToken,
      sessionToken,
      uuid,
      userId
    } = auth;
    _Bookmark.default.getAll(applicationToken, sessionToken, uuid, userId).then(response => setBookmarks(response.data));
  }
  function onRemove() {
    return _onRemove.apply(this, arguments);
  }
  function _onRemove() {
    _onRemove = _asyncToGenerator(function* () {
      var bookmarkToRemove = bookmarks.find(bookmark => bookmark.page_reference === String(pdf.viewer.currentPageNumber));
      yield _Bookmark.default.remove(auth.applicationToken, auth.sessionToken, Number(bookmarkToRemove.id));
      loadBookmarks();
    });
    return _onRemove.apply(this, arguments);
  }
  function onCreate(_x) {
    return _onCreate.apply(this, arguments);
  }
  function _onCreate() {
    _onCreate = _asyncToGenerator(function* (payload) {
      var response = yield _Bookmark.default.create(auth.applicationToken, auth.sessionToken, payload);
      var {
        data
      } = response;
      trackService.trackBookmark({
        chapter: data.chapter_name,
        bookmark: data.id
      });
      loadBookmarks();
    });
    return _onCreate.apply(this, arguments);
  }
  function handleUserBookmark(_x2) {
    return _handleUserBookmark.apply(this, arguments);
  }
  function _handleUserBookmark() {
    _handleUserBookmark = _asyncToGenerator(function* (pdf) {
      var page = pdf.viewer.currentPageNumber;
      var pdfTitle = yield _PdfReader.default.getBookTitle(pdf);
      var chapterTitle = yield _PdfReader.default.getOutlineByPage(pdf, page);
      var chapterDescription = yield _PdfReader.default.getContentFromPage(pdf, page);
      var title = (chapterTitle === null || chapterTitle === void 0 ? void 0 : chapterTitle.title) || pdfTitle || auth.bookTitle;
      var description = chapterDescription.items[2].str.trim().substring(0, 50);
      var payload = {
        chapter_name: title,
        page_reference: String(page),
        summary: description,
        book_id: auth.uuid,
        user_id: auth.userId
      };
      if (isPageBookmarked) {
        onRemove();
      } else {
        onCreate(payload);
      }
    });
    return _handleUserBookmark.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    className: _reactDeviceDetect.isIOS13 || _reactDeviceDetect.isIOS ? classes.bottomIOS : classes.bottomWrapper,
    style: {
      backgroundColor: theme.reader.backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    arrow: true,
    className: classes.tooltip,
    title: "Menu"
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: "Menu",
    icon: /*#__PURE__*/_react.default.createElement(_icons.FormatListBulleted, null),
    value: "summary",
    onClick: () => setOpenDrawer(true),
    disabled: !pdf,
    style: {
      color: theme.reader.color
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    placement: "top",
    arrow: true,
    className: classes.tooltip,
    title: "Marcar p\xE1gina"
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
    label: isPageBookmarked ? 'Página marcada' : 'Marcar página',
    icon: isPageBookmarked ? /*#__PURE__*/_react.default.createElement(_icons.Bookmark, null) : /*#__PURE__*/_react.default.createElement(_icons.BookmarkBorder, null),
    onClick: () => handleUserBookmark(pdf),
    value: "toggleBookmark",
    disabled: !pdf,
    style: {
      color: theme.reader.color
    }
  })), /*#__PURE__*/_react.default.createElement(_index.default, {
    openDrawer: openDrawer,
    setOpenDrawer: setOpenDrawer,
    title: title,
    chapters: chapters,
    pdf: pdf
  }));
}
BottomNavigation.propTypes = {
  pdf: _propTypes.default.object
};
var _default = exports.default = BottomNavigation;